export const PRODUCT_CODES = {
  tmUSPTOFilingFee: 'TRADEMARK_USPTOFilingFee',
  tmRushProcessing: 'TRADEMARK_Trademark_Rush_Processing',
  tmRegisterTrademark: 'TRADEMARK_RegisterTrademark',
  tmSearchFederalState: 'TRADEMARK_Trademark_Search_Federal_State',
  tmSearchCommonLow: 'TRADEMARK_Trademark_Search_Common_Law',
  tmSearchBasic: 'TRADEMARK_Trademark_Search_Basic',
  tmSearchGlobal: 'TRADEMARK_Trademark_Search_Global',
  tmMonitoring: 'TRADEMARK_Trademark_Monitoring',
  tmOfficeActionResponse: 'TRADEMARK_Trademark_Office_Action_Response',
  tmStatementOfUse: 'TRADEMARK_Trademark_Statement_Of_Use_Standalone',
  tmStatementOfUseUSPTO: 'TRADEMARK_SOU_USPTO_Fee',
  tmRenewal: 'TRADEMARK_Trademark_Renewal',
  tmExtension: 'TRADEMARK_Trademark_Extension_Standalone',
  tmRevivalFromAbandonment:
    'TRADEMARK_Trademark_Revival_From_Abandonment_Standalone',
  tmKeepTrademarkAlive: 'TRADEMARK_Trademark_Keep_Trademark_Alive',
  tmCertifiedCopy: 'TRADEMARK_Trademark_Certified_Copy',
  tmPrivateContactInfo: 'TRADEMARK_Private_Contact_Information',
  tmPrivacyPackage: 'TRADEMARK_Privacy_Package',
  tmLogoDesignService: 'TRADEMARK_Logo_Design_Service',
  tmLegalTeamTrademarkAssessment: 'TRADEMARK_Legal_Team_Trademark_Assessment',
};

export const SYNTHETIC_PRODUCT_CODES = {
  tmPrivacyComplex: 'TRADEMARK_Privacy_Complex',
};
